import React from 'react';
import ModalClose from './video_close';

const VideoPlayer = ({ video, captions, width, height, onClick }) => (
  <>
    <video
      className="width-100 height-100"
      width={width}
      height={height}
      controls>
      <source src={video} type="video/mp4" />
      <track default kind="captions" srcLang="en" src={captions} />
      Your browser does not support the video tag.
    </video>
    <ModalClose onClick={onClick} onFocus={onClick} />
  </>
);

export default VideoPlayer;
